/**
 * @GpsTable.vue
 * @Description GPS标签管理组件
 * @Author CC
 * @Date 2025/09/20
 */
/* HTML */
<template>
	<div class="table-item-box padding-l-none">
		<section style="height: 100%;">
			<!--查询工具条-->
			<el-col style="padding-bottom: 0px;text-align: left;height: 52px;">
				<el-form :inline="true" :model="filters" ref="filters">
					<el-form-item>查询条件：</el-form-item>
					<el-form-item v-if="false" prop="key">
						<el-select v-model="filters.key" placeholder="请选择账户" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in accountManagerInfos" :key="key" :label="value.account" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<!--					<el-form-item prop="type">
						<el-select v-model="filters.type" placeholder="请选择设备类型" clearable @change="researchGpsTag">
							<el-option v-for="(value,key) in types" :key="key" :label="value" :value="key"></el-option>
						</el-select>
					</el-form-item>-->
					<el-form-item prop="simExpirationTime">
						<el-date-picker v-model="filters.simExpirationTime" type="date" value-format="yyyy-MM-dd" placeholder="选择流量过期日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="simStatus">
						<el-select v-model="filters.simStatus" placeholder="请选择流量卡状态" clearable @change="researchGpsTag">
							<el-option v-for="(item, index) in simStatus" :key="index" :label="item" :value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="keyword">
						<el-input v-model="filters.keyword" placeholder="请输入设备编号/SIM卡号" clearable @keyup.enter.native="researchGpsTag" :style="{width: '300px'}">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="researchGpsTag"></i>
						</el-input>
					</el-form-item>
					<el-form-item style="position: absolute;top: 9px;right: 10px;z-index: 3;margin: 0;">
						<el-button type="primary" size="mini" trigger="click" @click="updateSim"><i class="el-icon-refresh" /> 更新流量卡</el-button>
						<el-button type="primary" size="mini" trigger="click" @click="searchExportData"><i class="el-icon-download" /> 导出流量卡</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 表格 -->
			<el-table :data="tagInfos" @sort-change="changeSort" ref="multipleTable" stripe style="width: 100%;height: calc(100% - 96px);" @row-click="rowHandle" :class="{'table': true, 'no-pagination': false}">
				<el-table-column type="selection" :selectable="checkSelectable" />
				<el-table-column label="序号" type="index" width="60px">
					<template v-slot="scope">
						{{ scope.$index + 1}}
					</template>
				</el-table-column>
				<!--				<el-table-column label="类型" min-width="80px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'类型: ' + scope.row.type">
                            {{types[scope.row.type]}}
                        </span>
					</template>
				</el-table-column>-->
				<el-table-column label="设备编号" width="150px" :sortable="filters.sortable" prop="did" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'设备编号: ' + scope.row.did">
                            {{scope.row.did}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="流量卡号" min-width="180px" :sortable="filters.sortable" prop="iccid" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'流量卡号: ' + scope.row.iccid">
                            {{scope.row.iccid}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="imsi" min-width="140px" :sortable="filters.sortable" prop="imsi" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'imsi: ' + scope.row.imsi">
                            {{scope.row.imsi}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="imei" min-width="150px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'imei: ' + scope.row.imei">
                            {{scope.row.imei==null||scope.row.imei=='000000000000000000000000000000'?"":(scope.row.imei)}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="套餐" min-width="120px" v-if="$store.getters.getUserRoleId=='1'">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'套餐: ' + scope.row.simPackage">
                            {{scope.row.simPackage}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="状态" min-width="80px" :sortable="filters.sortable" prop="sim_status" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'SIM卡状态: ' + scope.row.simStatus">
                            {{scope.row.simStatus}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="已用" min-width="90px" :sortable="filters.sortable" prop="simUsed" :sort-orders="filters.sortOrders" v-if="$store.getters.getUserRoleId=='1'">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'已用流量/M: ' + scope.row.simUsed">
                            {{scope.row.simUsed==null?"":(scope.row.simUsed + 'M')}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="过期时间" min-width="150px" :sortable="filters.sortable" prop="sim_activation_time" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="'过期时间: ' + $moment(scope.row.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')">
                            {{$moment(scope.row.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="所属账户" min-width="120px" prop="key" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="accountManagerInfos[scope.row.key] ? accountManagerInfos[scope.row.key].account : ''">
                            {{accountManagerInfos[scope.row.key] ? accountManagerInfos[scope.row.key].account : ''}}
                        </span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template v-slot="scope">
						<span style="cursor: pointer;margin-right: 10px;" class="el-icon-circle-plus-outline" type="text" size="mini" @click="()=>{addSim(scope.row, scope.$index)}" trigger="click" v-if="scope.row.iccid==null || scope.row.iccid == ''">添加</span>
						<span style="cursor: pointer;margin-right: 10px;" class="el-icon-edit" type="text" size="mini" @click="()=>{editSim(scope.row, scope.$index)}" trigger="click" v-else>更换</span>
						<span style="cursor: pointer;" class="el-icon-refresh" type="text" size="mini" @click="()=>{trigerSim(scope.row, scope.$index)}" trigger="click">更新</span>
					</template>
				</el-table-column>
			</el-table>

			<!--分页工具条-->
			<Pagination :currentPage="pagination.currentPage" :total="pagination.total" :pageSize="pagination.limit" @handleSizeChangeSub="handleSizeChangeSub" @handleCurrentChangeSub="handleCurrentChangeSub" />

			<!-- ======================= 导出所需数据 =============================== -->
			<el-table :data="exportDatas" id="out-sim-table" stripe style="display: none;" class="table">
				<el-table-column label="设备编号">
					<template v-slot="scope">
						{{scope.row.did}}
					</template>
				</el-table-column>
				<el-table-column label="流量卡号">
					<template v-slot="scope">
						{{scope.row.iccid}}
					</template>
				</el-table-column>
				<el-table-column label="imsi">
					<template v-slot="scope">
						{{scope.row.imsi}}
					</template>
				</el-table-column>
				<el-table-column label="imei">
					<template v-slot="scope">
						{{scope.row.imei==null||scope.row.imei=='000000000000000000000000000000'?"":(scope.row.imei)}}
					</template>
				</el-table-column>
				<el-table-column label="套餐">
					<template v-slot="scope">
						{{scope.row.simPackage}}
					</template>
				</el-table-column>
				<el-table-column label="状态" min-width="100px">
					<template v-slot="scope">
						{{scope.row.simStatus}}
					</template>
				</el-table-column>
				<el-table-column label="已用流量/M">
					<template v-slot="scope">
						{{scope.row.simUsed==null?"":(scope.row.simUsed)}}
					</template>
				</el-table-column>
				<el-table-column label="激活时间">
					<template v-slot="scope">
						{{scope.row.simActivationTime}}
					</template>
				</el-table-column>
				<el-table-column label="过期时间">
					<template v-slot="scope">
						{{$moment(scope.row.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="地址">
					<template v-slot="scope">
						{{scope.row.address}}
					</template>
				</el-table-column>
				<el-table-column label="所属账户">
					<template v-slot="scope">
						{{accountManagerInfos[scope.row.key] ? accountManagerInfos[scope.row.key].account : ''}}
					</template>
				</el-table-column>
			</el-table>

		</section>

		<!-- 流量卡配置 -->
		<GpsTagSimConfigDialog ref="gpsTagSimConfigDialog" @searchGpsTag="searchGpsTag" />
	</div>
</template>

/* JS */
<script>
	// gps标签组件
	import ApiGpsTag from '@/request/api-gps-tag'
	import ApiOrg from '@/request/api-org'
	// 弹框组件
	import GpsTagSimConfigDialog from '@/components_outdoor/Device/GpsTagSimConfigDialog'
	// 分页组件
	import Pagination from '@/components/Pagination.vue'
	// 公共函数
	import GlobalFun from "@/global/global-function";

	export default {
		/**
		 * 组件名称
		 */
		name: "GpsTagSimTable",
		/**
		 * 组件引用
		 */
		components: {
			// 标签弹出层组件
			GpsTagSimConfigDialog,
			// 分页工具
			Pagination,
		},
		/**
		 * @Des 数据接收
		 * @Auth 
		 * @Date 2025/09/20
		 */
		props: {
			/**
			 * @Des 管理员账户
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			accountManagerInfos: {
				type: Object,
				default: function() {
					return {}
				}
			},
		}, // props
		/**
		 * 数据定义
		 * @returns {{}}
		 */
		data() {
			return {
				/**
				 * @Des 查询条件属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				filters: {
					projectId: '',
					key: '', // 所属账户 key
					keyword: '',
					status: '',
					type: '',
					simStatus: '',
					orderBy: {
						'status': 'asc',
						"upload_time": "desc",
					},
					sortOrders: [
						"ascending",
						"descending"
					],
					sortable: 'custom',
					simExpirationTime: ''
				},
				// 基站集合
				tagInfos: [],
				exportDatas: [],
				projectInfos: {},
				locked: false,
				status: {
					1: '在线',
					2: '离线'
				},
				types: {
					'01': '电子护照',
					'02': '2A',
					'03': '蹄子',
					'05': '2G安全帽',
					'0E': '手牵手',
					'06': '测试定位标签',
					'0A': '定位标签',
					'0B': '室内外安全帽',
					'0C': '4G安全帽',
					'0F': '车载终端',
				},
				simStatus: [
					"系统初始化",
					"卡号错误",
					"待激活",
					"已激活",
					"停机",
					"测试期",
					"库存期",
					"预销户",
					"已销户",
					"沉默期",
					"单向停机",
					"休眠",
					"过户",
					"非激活",
					"未知"
				],
				/**
				 * 分页数据
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 50,
					currentPage: 1
				},
				/**
				 * 上传属性
				 */
				upload: {
					previewTitle: [],
					previewData: [],
					saveUrl: '',
					showSerialNumber: true
				},
				/**
				 * 样式修改
				 *
				 */
				surroundSpan(value) {
					return '<span style="white-space: nowrap;" title="' + value + '">' + value + '</span>';
				},
				/**
				 * 上传配置
				 */
				uploadGpsTag: {
					myHeaders: {
						token: this.$store.state.token,
						lang: this.$store.state.lang,
						loginDevice: this.$store.state.loginDevice
					},
					saveUrl: ApiGpsTag.addGpsTagApi,
				},
				/**
				 * @Description 上传配置
				 * @Param
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				uploadGpsTagId: {
					myHeaders: {
						token: this.$store.state.token,
						lang: this.$store.state.lang,
						loginDevice: this.$store.state.loginDevice
					},
					uploadUrl: ApiGpsTag.batchUpdateGpsTagIdsApi,
					saveUrl: ApiGpsTag.addGpsTagIdApi
				},
				// 查询未加入项目的标签
				limit: 3000,
				
				// route params
				routeParams: {},
			}
		},
		computed: {},
		created() {
			// 查询登录账户的项目
			// this.searchAccountProject();
		},// created
		mounted() {
			this.routeParams = Object.assign({}, this.$route.params);
			if (this.routeParams.currentMonthLastTime) {
				this.filters.simExpirationTime = this.$moment(this.routeParams.currentMonthLastTime).format('YYYY-MM-DD HH:mm:ss');
			}
			
			// 查询标签
			this.searchGpsTag();
		},// mounted
		/**
		 * 方法定义
		 */
		methods: {
			/**
			 * 更新SIM卡信息
			 */
			updateSim() {
				let selection = this.$refs.multipleTable.selection;
				if(selection.length == 0) {
					this.$message({
						message: '请选择要更新的流量卡号',
						type: 'info',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				let iccids = [];
				selection.forEach((row, index) => {
					if(row.iccid != null && row.iccid != '') {
						iccids.push(row.iccid);
					}
				})
				if(iccids.length == 0) {
					this.$message({
						message: "请选择流量卡",
						type: 'warning',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}
				let param = {
					iccids: iccids
				};
				this.$confirm(
					'确认要更新流量卡信息吗？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					// loading
					this.loading = this.$loading({
						lock: true,
						text: '正在查询流量卡信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$request.postJsonRequest(ApiGpsTag.updateSimApi, param).then(result => {
						if(result.code == 0) {
							this.$message({
								message: '流量卡更新成功',
								type: 'success',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
							this.searchGpsTag();
							this.loading.close();
						}
					}).catch(error => {
						this.$message({
							message: "流量卡更新异常：" + this.$request.error.msg,
							type: 'warning',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
						this.loading.close();
					})
				});
			},

			/**
			 * @Description
			 * @Param 查询登录账户的项目
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchAccountProject() {
				return false;
				this.$request.postJsonRequest(ApiOrg.findLoginProjectApi, {}).then(result => {
					this.projectInfos = Object.assign({}, {});
					if(result.code == 0) {
						result.data.forEach((row, index) => {
							let projectId = row.projectId;
							this.projectInfos[projectId] = row;
						})
					}
				}).catch(error => {
					console.log("查询登录项目异常：" + this.$request.error.msg);
				})
			},
			/**
			 * @Description
			 * @Param 查询gps标签
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchGpsTag() {
				this.filters.keyword = this.filters.keyword.toUpperCase().trim();
				this.$request.postJsonRequest(ApiGpsTag.searchGpsTagApi, {
					key: this.filters.key,
					type: this.filters.type,
					simStatus: this.filters.simStatus,
					keyword: this.filters.keyword,
					simExpirationTime: this.filters.simExpirationTime,
					orderBy: this.filters.orderBy,
					total: this.pagination.total,
					startNum: this.pagination.startNum,
					limit: this.pagination.limit,
				}).then(result => {
					// console.log(result)
					this.tagInfos = [];
					// 总数
					this.pagination.total = result.total;
					if(result.total > 0) {
						result.rows.forEach((row, index) => {
							if(this.projectInfos.hasOwnProperty(row.projectId)) {
								row.projectName = this.projectInfos[row.projectId].projectName;
							}
							if(this.accountManagerInfos.hasOwnProperty(row.key)) {
								row.account = this.accountManagerInfos[row.key].account;
							}
							this.tagInfos.push(row);
						});
					}
					// console.log(this.bsInfos)
				}).catch(error => {
					console.log("查询标签异常：" + this.$request.error.msg);
				})
			},
			/**
			 * @Description
			 * @Param 是否选择
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			checkSelectable(row) {
				return true;
			},
			/**
			 * @Description
			 * @Param 重新搜索
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			researchGpsTag() {
				this.pagination.total = 0;
				this.pagination.startNum = 0;
				this.pagination.currentPage = 1;
				this.searchGpsTag();
			},
			/**
			 * @Description
			 * @Param 改变排序
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			changeSort(data) {
				let prop = data.prop;
				let order = data.order;
				if(order == null) {
					order = this.filters.orderBy[prop];
				} else {
					order = order.replace("ending", "");
				}
				if(order == null) {
					this.filters.orderBy["sid"] = "asc";
				} else {
					this.filters.orderBy = {};
					this.filters.orderBy[prop] = order;
				}
				this.researchGpsTag();
			},
			/**
			 * @Description
			 * @Param 当前页数据改变
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleCurrentChangeSub(val) {
				this.pagination.currentPage = val;
				this.pagination.startNum = this.pagination.limit * (val - 1);
				this.searchGpsTag();
			},
			/**
			 * @Description
			 * @Param 页长度改变
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleSizeChangeSub(val) {
				this.pagination.limit = val;
				this.pagination.currentPage = 1;
				this.pagination.startNum = 0;
				this.searchGpsTag();
			},

			/**
			 * @Description
			 * @Param 处理行
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			rowHandle(row) {
				if(row.checked) {
					row.checked = false;
				} else {
					row.checked = true;
				}
				this.$refs.multipleTable.toggleRowSelection(row, row.checked)
			},

			/**
			 * @Des 查询导出数据
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchExportData() {
				this.$confirm(
					'确认要导出查询到的流量卡信息吗？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					this.loading = this.$loading({
						lock: true,
						text: '正在查询流量卡信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$request.postJsonRequest(ApiGpsTag.searchGpsTagApi, {
						key: this.filters.key,
						keyword: this.filters.keyword.toUpperCase().trim(),
						simExpirationTime: this.filters.simExpirationTime,
						orderBy: this.filters.orderBy,
						total: 0,
						startNum: 0,
						limit: 0,
					}).then(result => {
						this.exportDatas = Object.assign([], []);
						if(result.total > 0) {
							// console.log(result.rows)
							result.rows.forEach((row, index) => {
								if(this.projectInfos.hasOwnProperty(row.projectId)) {
									row.projectName = this.projectInfos[row.projectId].projectName;
									row.hasArea = this.projectInfos[row.projectId].hasArea;
								}
								if(this.accountManagerInfos.hasOwnProperty(row.key)) {
									row.account = this.accountManagerInfos[row.key].account;
								}
								this.exportDatas.push(row);
							});
						}
						// console.log(this.exportDatas);
						this.$nextTick(() => {
							GlobalFun.exportExcel(document.querySelector("#out-sim-table"), 'GPS标签流量卡信息.xlsx');
							this.loading.close();
						})
					}).catch(error => {
						console.log("导出流量卡异常：" + ApiGpsTag.searchGpsTagApi);
						this.loading().close()
					})
				});
			},

			/**
			 * 添加SIM卡
			 * @param row
			 * @param index
			 */
			addSim(row, index) {
				// console.log(row, index);
				this.$refs.gpsTagSimConfigDialog.openDialog(row, index, true);
			},

			/**
			 * 修改SIM卡
			 * @param row
			 * @param index
			 */
			editSim(row, index) {
				// console.log(row, index);
				this.$refs.gpsTagSimConfigDialog.openDialog(row, index, false);
			},

			trigerSim(row, index) {
				let param = {
					iccids: [row.iccid]
				};
				this.$confirm(
					'确认要更新【' + row.iccid + '】流量卡信息吗？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					// loading
					this.loading = this.$loading({
						lock: true,
						text: '正在查询流量卡信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$request.postJsonRequest(ApiGpsTag.updateSimApi, param).then(result => {
						if(result.code == 0) {
							this.$message({
								message: '流量卡更新成功',
								type: 'success',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
							this.searchGpsTag();
							this.loading.close();
						}
					}).catch(error => {
						this.$message({
							message: "流量卡更新异常：" + this.$request.error.msg,
							type: 'warning',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
						this.loading.close();
					})
				});
			},
			searchKeyword(data) {
				this.filters.keyword = data;
				this.researchGpsTag();
			}

		}
	}
</script>

/* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagSimTable.vue